"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CodeBenchv2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// React imports
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
// UI Imports
var ui_common_1 = require("@codametrix/ui-common");
var ui_components_1 = require("@codametrix/ui-components");
// Components imports
var ui_common_2 = require("@codametrix/ui-common");
var spinner_svg_1 = __importDefault(require("../../assets/spinner/spinner.svg"));
var code_bench_vw_modal_1 = __importDefault(require("./code-bench.vw-modal"));
var billing_group_1 = require("../billing-group/billing-group");
var code_bench_panelv2_1 = require("../code-bench-panel/code-bench-panelv2");
var case_detailv2_1 = require("../case-detail/case-detailv2");
var code_bench_action_barv2_1 = require("../code-bench-action-bar/code-bench-action-barv2");
var process_status_1 = require("../process-status/process-status");
var charge_counts_1 = require("../code-bench-panel/charge-counts/charge-counts");
var confirm_1 = require("../confirm/confirm");
var charge_selector_1 = require("../charge-selector/charge-selector");
var improvements_1 = require("../improvements/improvements");
var related_cases_1 = require("../related-cases/related-cases");
var case_status_1 = require("../case-status/case-status");
var standalone_pageable_list_1 = require("../standalone-pageable-list/standalone-pageable-list");
var conditional_1 = require("../conditional/conditional");
var case_alert_1 = require("../case-alert/case-alert");
var window_open_args_1 = require("../case-detail/window-open-args");
var grade_bench_panel_generalized_1 = __importDefault(require("../code-bench-panel/grade-bench-panel-generalized"));
var invoice_metadata_form_fixtures_1 = require("../code-bench-panel/invoice-metadata/invoice-metadata-form-fixtures");
var purpose_guideline_1 = require("./purpose-guideline/purpose-guideline");
var code_bench_action_bar_component_utilities_1 = require("../code-bench-action-bar/code-bench-action-bar-component-utilities");
var workitem_selector_1 = require("../code-bench-action-bar/item-selector/workitem-selector");
var CaseAlertType = ui_common_1.commonEnums.CaseAlertType, AccelerateProcessStatus = ui_common_1.commonEnums.AccelerateProcessStatus;
var getChildWindowParams = ui_common_1.caseUtils.getChildWindowParams;
var TitleTabsEnum;
(function (TitleTabsEnum) {
    TitleTabsEnum["CHANGES_TEXT"] = "See changes to this case";
})(TitleTabsEnum || (TitleTabsEnum = {}));
var conditionalUtils = ui_common_1.AmplifyCore.conditionalUtils;
/**
 * Place to update, transform, or modify property config.
 *
 * This function can help to separate the the React view from the React state before
 * sharing the object with PatientEncounterv2
 *
 * @param UpdatePropertyConfig
 * @returns An updated PatientInformationConfiguration
 */
function updatePropertyConfig(_a) {
    var serviceLine = _a.serviceLine, benchMode = _a.benchMode, propertyConfig = _a.propertyConfig;
    var _serviceLine = serviceLine ? serviceLine.toLocaleLowerCase() : '';
    // For cqa workflow, serviceLine comes from activeItem which is set in code-bench.reducer.ts when loadCQAItemFromURL.
    // This service line is specifically based on the cqa-service workitem. Product requirement is to display
    // exam_description in CQA grading screen only for radiology.
    if (benchMode === ui_common_1.commonEnums.BenchMode.GRADE) {
        return __assign(__assign({}, propertyConfig), { summary: propertyConfig.summary.filter(function (summary) {
                if (summary.key === 'exam_description' &&
                    !['radiology'].includes(_serviceLine)) {
                    return false;
                }
                return true;
            }) });
    }
    return __assign({}, propertyConfig);
}
var CodeBenchv2 = /** @class */ (function (_super) {
    __extends(CodeBenchv2, _super);
    function CodeBenchv2(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Event that happen when Enter key is pressed on  add charge button
         * @returns {void}
         */
        _this.handleKeyDown = function (ev) {
            if (ev.key === 'Enter') {
                ev.preventDefault();
                _this.onModalAddChargeOpen();
            }
        };
        _this.onCodeUpdate = _this.onCodeUpdate.bind(_this);
        _this.onCodeRemove = _this.onCodeRemove.bind(_this);
        _this.onTimeBasedCodeAdd = _this.onTimeBasedCodeAdd.bind(_this);
        _this.onTimeBasedCodeUpdate = _this.onTimeBasedCodeUpdate.bind(_this);
        _this.onCodeSearchDrop = _this.onCodeSearchDrop.bind(_this);
        _this.onCodeSearch = _this.onCodeSearch.bind(_this);
        _this.onCodeSearchSelection = _this.onCodeSearchSelection.bind(_this);
        _this.onAddAllCodes = _this.onAddAllCodes.bind(_this);
        _this.onRemoveAllCodes = _this.onRemoveAllCodes.bind(_this);
        _this.createTransactionAndAddCode = _this.createTransactionAndAddCode.bind(_this);
        _this.onFeatureSelection = _this.onFeatureSelection.bind(_this);
        _this.handleGroupedCaseClick = _this.handleGroupedCaseClick.bind(_this);
        _this.handleModalClose = _this.handleModalClose.bind(_this);
        _this.handleInvoiceEdit = _this.handleInvoiceEdit.bind(_this);
        _this.handlePromptDismiss = _this.handlePromptDismiss.bind(_this);
        _this.handleMetaAction = _this.handleMetaAction.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.onModalAddChargeOpen = _this.onModalAddChargeOpen.bind(_this);
        _this.onModalAddChargeClose = _this.onModalAddChargeClose.bind(_this);
        _this.handleAddCharge = _this.handleAddCharge.bind(_this);
        _this.handleTimer = _this.handleTimer.bind(_this);
        _this.handleInvoiceAddition = _this.handleInvoiceAddition.bind(_this);
        _this.handleTransactionSharedDiagnosisChange = _this.handleTransactionSharedDiagnosisChange.bind(_this);
        _this.handleDeleteSizeExpWarning = _this.handleDeleteSizeExpWarning.bind(_this);
        _this.handleEnableTechPro = _this.handleEnableTechPro.bind(_this);
        _this.handleDisableTechPro = _this.handleDisableTechPro.bind(_this);
        _this.caseDetailRef = react_1["default"].createRef();
        _this.iframeRef = react_1["default"].createRef();
        var codeUpdateDebounced = _this.onCodeUpdate.bind(_this);
        _this.onCodeUpdate = ui_common_2.objectUtils.debounce(codeUpdateDebounced, 500);
        _this.handleHARCaseList = _this.handleHARCaseList.bind(_this);
        return _this;
    }
    CodeBenchv2.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (!this.props.loadAlwaysFromURL)
            return;
        if (((_a = prevProps.match) === null || _a === void 0 ? void 0 : _a.url) !== ((_b = this.props.match) === null || _b === void 0 ? void 0 : _b.url)) {
            this.props.match.params.getCaserunWithRefresh = conditionalUtils.capabilityValue((_g = (_f = (_e = (_d = (_c = this.props) === null || _c === void 0 ? void 0 : _c.capabilities) === null || _d === void 0 ? void 0 : _d.capabilities) === null || _e === void 0 ? void 0 : _e.getCaseRunWithRefresh) === null || _f === void 0 ? void 0 : _f.on) !== null && _g !== void 0 ? _g : false);
            this.props.onLoadFromURLMatch(this.props.match);
            var case_uid = (_j = (_h = this.props.match) === null || _h === void 0 ? void 0 : _h.params) === null || _j === void 0 ? void 0 : _j.caseId;
            var caserun_uid = (_l = (_k = this.props.match) === null || _k === void 0 ? void 0 : _k.params) === null || _l === void 0 ? void 0 : _l.id;
            this.props.loadWorkItemDetails(case_uid, caserun_uid);
            if (this.props.benchMode == ui_common_1.commonEnums.BenchMode.GRADE) {
                this.props.fetchGradePanelConfigurations();
                this.props.fetchQaRule({
                    qaCollectionUuid: this.props.cursorAPIContext.qaCollectionUuid,
                    level: 3,
                    service: this.props.cursorAPIContext.launchConfigServiceLine
                });
                this.props.fetchWorkerInfoForUser(this.props.userContext);
            }
        }
        if (this.props.benchMode == ui_common_1.commonEnums.BenchMode.GRADE) {
            if (prevProps.gradeableInvoices !== this.props.gradeableInvoices) {
                this.props.fetchGraderWorkItemActivity(this.props.match.params.id);
            }
        }
    };
    CodeBenchv2.prototype.componentDidMount = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.props.loadRoles(this.props.roles);
        var hasActiveItem = !ui_common_2.objectUtils.isEmpty(this.props.activeItem);
        var case_uid = '', caserun_uid = '';
        if (this.props.loadAlwaysFromURL || !hasActiveItem) {
            this.props.match.params.getCaserunWithRefresh = conditionalUtils.capabilityValue((_e = (_d = (_c = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.capabilities) === null || _b === void 0 ? void 0 : _b.capabilities) === null || _c === void 0 ? void 0 : _c.getCaseRunWithRefresh) === null || _d === void 0 ? void 0 : _d.on) !== null && _e !== void 0 ? _e : false);
            this.props.onLoadFromURLMatch(this.props.match);
            case_uid = (_g = (_f = this.props.match) === null || _f === void 0 ? void 0 : _f.params) === null || _g === void 0 ? void 0 : _g.caseId;
            caserun_uid = (_j = (_h = this.props.match) === null || _h === void 0 ? void 0 : _h.params) === null || _j === void 0 ? void 0 : _j.id;
        }
        else {
            this.props.onLoad(this.props.activeItem);
            case_uid = this.props.activeItem.case_uid;
            caserun_uid = this.props.activeItem.caserun_uid;
        }
        this.props.loadWorkItemDetails(case_uid, caserun_uid);
        // Loads cursorAPIContext from connected props(from dashboard-ui) to capabilities state(shared-views)
        this.props.loadServicedeskContext(this.props.cursorAPIContext);
        if (this.props.benchMode == ui_common_1.commonEnums.BenchMode.GRADE) {
            this.props.fetchGradePanelConfigurations();
            this.props.fetchQaRule({
                qaCollectionUuid: this.props.cursorAPIContext.qaCollectionUuid,
                level: 3,
                service: this.props.cursorAPIContext.launchConfigServiceLine
            });
        }
    };
    CodeBenchv2.prototype.handleCancel = function (event) {
        event.preventDefault();
        this.props.onInvoicesCancel(this.props.processInstance);
    };
    CodeBenchv2.prototype.handleSubmit = function (event, vwComment, submitWithOverrideButton, remove_hold) {
        var _a, _b;
        if (vwComment === void 0) { vwComment = null; }
        if (submitWithOverrideButton === void 0) { submitWithOverrideButton = false; }
        if (remove_hold === void 0) { remove_hold = null; }
        event.preventDefault();
        var cursorAPIPayload = {
            operation: ui_common_1.commonEnums.CursorOperation.NEXT,
            cursorAPIContext: this.props.cursorAPIContext,
            hasAmplifyCaseRunV2Access: conditionalUtils.capabilityValue((_b = (_a = this.props.capabilities.capabilities.amplifyCaseRunV2) === null || _a === void 0 ? void 0 : _a.on) !== null && _b !== void 0 ? _b : false)
        };
        this.props.onInvoicesSubmisson({
            processInstance: this.props.processInstance,
            uiMode: this.props.UIMode,
            vwComment: vwComment,
            submitWithOverrideButton: submitWithOverrideButton,
            cursorAPIPayload: cursorAPIPayload,
            activeItem: this.props.activeItem,
            removeHold: remove_hold
        });
    };
    CodeBenchv2.prototype.handlePreviousClick = function (event) {
        event.preventDefault();
        var _a = this.props, processInstanceGuids = _a.processInstanceGuids, activeItem = _a.activeItem;
        var loc = processInstanceGuids.findIndex(function (item) { return item === activeItem.process_instance_guid; });
        this.props.handleTraversal(processInstanceGuids[loc - 1]);
    };
    CodeBenchv2.prototype.handleModalClose = function (ev) {
        ev.preventDefault();
        this.props.onPopUpClose();
    };
    CodeBenchv2.prototype.handlePromptDismiss = function (ev) {
        ev.preventDefault();
        this.props.onPrompt('REFRESH_TOKEN');
    };
    CodeBenchv2.prototype.handleConfirm = function (actionItem) {
        this.props.onPopUpClose();
    };
    CodeBenchv2.prototype.handleConfirmDismiss = function (actionItem) {
        this.props.onPopUpClose();
    };
    CodeBenchv2.prototype.handleInvoiceEdit = function (invoice) {
        this.props.onInvoiceEdit(invoice, this.props.processInstance);
    };
    CodeBenchv2.prototype.handleInvoiceAddition = function (invoices) {
        this.props.onInvoiceAddition((invoices && invoices.length > 0
            ? invoices[0]
            : null), this.props.processInstance);
    };
    CodeBenchv2.prototype.handleMetaAction = function (transactionAction) {
        var invoice = this.props.codableInvoices.find(function (invoice) { return invoice.guid === transactionAction.meta.invoice.guid; });
        this.props.onChargeSessionAction(__assign(__assign({}, transactionAction), { meta: __assign(__assign({}, transactionAction.meta), { invoice: invoice, processInstance: this.props.processInstance }) }));
    };
    CodeBenchv2.prototype.handleGroupedCaseClick = function (ev) {
        ev.preventDefault();
        var target = ev.target || document.createElement('div');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
        if (!linkable)
            return;
        var item = linkable.attributes.getNamedItem('data-case-id');
        if (!item)
            return;
        var caseId = item.value;
        if (!caseId)
            return;
        var hostCaseId = this.props.hostCaseId
            ? this.props.hostCaseId
            : this.props.activeItem.case_id;
        var replace = hostCaseId !== this.props.activeItem.case_id;
        this.props.onPopUpNavigate({
            caseId: item.value,
            replace: replace,
            serviceLine: this.props.activeItem.service_line,
            hostCaseId: hostCaseId
        });
    };
    CodeBenchv2.prototype.onFeatureSelection = function (selection) {
        this.props.onFeatureActivation(selection);
        this.caseDetailRef.current.onFeatureActivation(selection);
    };
    // The CodeQuery, SearchResult, and CodeChange all rely on a common
    // property called context.  This is what will allow business
    // logic upstream to have standard patterns for figuring out what to do
    // with various actions.
    CodeBenchv2.prototype.onCodeSearch = function (commonCodeQuery) {
        var context = __assign(__assign({}, commonCodeQuery.context), { activeItem: __assign({}, this.props.activeItem), userContext: __assign({}, this.props.userContext) });
        var codeQuery = __assign(__assign({}, commonCodeQuery), { context: context });
        var isMod = codeQuery.searchType === ui_common_1.commonEnums.CodeType.MODIFIER;
        if (isMod) {
            codeQuery.text = "".concat(codeQuery.text).toUpperCase();
        }
        //
        if (codeQuery.text.length > 2 || (codeQuery.text.length === 2 && isMod)) {
            this.props.onCodeSearch(codeQuery);
        }
    };
    CodeBenchv2.prototype.onCodeSearchSelection = function (commonSearchResult) {
        var _a, _b;
        var defaultPrevented = (_b = (_a = commonSearchResult.context) === null || _a === void 0 ? void 0 : _a.defaultPrevented) !== null && _b !== void 0 ? _b : false;
        if (defaultPrevented) {
            this.props.onSearchClear(commonSearchResult);
        }
        else {
            var context = __assign(__assign({}, commonSearchResult.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
            var searchResult = __assign(__assign({}, commonSearchResult), { context: context });
            this.props.onCodeSearchSelection(searchResult);
        }
    };
    CodeBenchv2.prototype.onAddAllCodes = function (commonSearchResult) {
        var _a, _b;
        if (ui_common_2.objectUtils.isEmpty(commonSearchResult === null || commonSearchResult === void 0 ? void 0 : commonSearchResult.codesInfo)) {
            return;
        }
        var defaultPrevented = (_b = (_a = commonSearchResult.context) === null || _a === void 0 ? void 0 : _a.defaultPrevented) !== null && _b !== void 0 ? _b : false;
        if (defaultPrevented) {
            this.props.onSearchClear({
                context: __assign(__assign({}, commonSearchResult.context), { activeItem: this.props.activeItem })
            });
        }
        else {
            var context = __assign(__assign({}, commonSearchResult.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
            var searchResult = {
                codesInfo: commonSearchResult.codesInfo,
                context: context
            };
            this.props.handleAddAllCodes(searchResult);
        }
    };
    CodeBenchv2.prototype.createTransactionAndAddCode = function (commonSearchResult) {
        this.props.createTransactionAndAddCode(commonSearchResult);
    };
    CodeBenchv2.prototype.onCodeUpdate = function (commonChangeDetail) {
        var context = __assign(__assign({}, commonChangeDetail.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
        var changeDetail = __assign(__assign({}, commonChangeDetail), { context: context });
        this.props.onCodeUpdate(changeDetail);
    };
    CodeBenchv2.prototype.onCodeRemove = function (commonChangeDetail) {
        var context = __assign(__assign({}, commonChangeDetail.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
        var changeDetail = __assign(__assign({}, commonChangeDetail), { context: context });
        this.props.onCodeRemove(changeDetail);
    };
    CodeBenchv2.prototype.onRemoveAllCodes = function (commonChangeDetail) {
        if (ui_common_2.objectUtils.isEmpty(commonChangeDetail === null || commonChangeDetail === void 0 ? void 0 : commonChangeDetail.codes)) {
            return;
        }
        var context = __assign(__assign({}, commonChangeDetail.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
        var changeDetail = __assign(__assign({}, commonChangeDetail), { context: context });
        this.props.handleRemoveAllCodes(changeDetail);
    };
    CodeBenchv2.prototype.onTimeBasedCodeAdd = function (commonChangeDetail, time, age) {
        var context = __assign(__assign({}, commonChangeDetail.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
        var codeChange = __assign(__assign({}, commonChangeDetail), { context: context });
        this.props.onTimeBasedCodeAdd(codeChange, time, age);
    };
    CodeBenchv2.prototype.onTimeBasedCodeUpdate = function (commonChangeDetail, time, age) {
        var context = __assign(__assign({}, commonChangeDetail.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
        var codeChange = __assign(__assign({}, commonChangeDetail), { context: context });
        this.props.onTimeBasedCodeUpdate(codeChange, time, age);
    };
    CodeBenchv2.prototype.onCodeSearchDrop = function (commonChangeDetail) {
        var context = __assign(__assign({}, commonChangeDetail.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
        var changeDetail = __assign(__assign({}, commonChangeDetail), { context: context });
        this.props.onCodeSearchDrop(changeDetail);
    };
    CodeBenchv2.prototype.handleTransactionSharedDiagnosisChange = function (changeDetail) {
        this.props.onTransactionSharedDiagnosisChange(changeDetail);
    };
    CodeBenchv2.prototype.handleHARCaseList = function (options) {
        var _a, _b, _c;
        this.props.getCasesWithEncounter({
            encounterId: (_b = (_a = this.props.activeItem) === null || _a === void 0 ? void 0 : _a.encounter_identifier) === null || _b === void 0 ? void 0 : _b.number,
            sortablePageable: options,
            serviceLine: (_c = this.props.activeItem) === null || _c === void 0 ? void 0 : _c.service_line,
            noteTypes: this.props.noteTypes
        });
    };
    /**
     * Event that happen when click add charge button
     * @returns {void}
     */
    CodeBenchv2.prototype.onModalAddChargeOpen = function () {
        this.props.onModalAddChargeOpen();
    };
    /**
     * Event that happen when moda of add charge button is closed
     * @returns {void}
     */
    CodeBenchv2.prototype.onModalAddChargeClose = function (e) {
        this.props.onModalAddChargeClose(e);
    };
    /**
     * Event launched when invoice is clicked
     */
    CodeBenchv2.prototype.handleAddCharge = function (invoice) {
        if (invoice.deleted) {
            this.handleInvoiceAddition([invoice]);
        }
        else {
            this.props.handleAddCharge({
                invoiceGuid: invoice.guid,
                processInstanceId: this.props.processInstance.guid.uuid,
                activeItem: this.props.activeItem
            });
        }
    };
    /**
     * Method that is called for decrement timer
     */
    CodeBenchv2.prototype.handleTimer = function () {
        this.props.handleTimer();
    };
    /**
     * Method that is called when user wants to close the modal for size experience warning
     */
    CodeBenchv2.prototype.handleDeleteSizeExpWarning = function () {
        this.props.deleteSizeExpWarning();
    };
    /**
     * Method used for enable a procedure with tech/pro charge
     * @param context
     */
    CodeBenchv2.prototype.handleEnableTechPro = function (techCodableTransaction) {
        techCodableTransaction.processInstance = this.props.processInstance;
        this.props.handleEnableTechPro(techCodableTransaction);
    };
    /**
     * Method used for disable a procedure with tech/pro charge
     * @param context
     */
    CodeBenchv2.prototype.handleDisableTechPro = function (techCodableTransaction) {
        techCodableTransaction.processInstance = this.props.processInstance;
        this.props.handleDisableTechPro(techCodableTransaction);
    };
    CodeBenchv2.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var _r = this.props, nonCodeBench = _r.nonCodeBench, chargeSessions = _r.chargeSessions, counts = _r.counts, searchResults = _r.searchResults, codeSearchResultsV2 = _r.codeSearchResultsV2, benchEditable = _r.benchEditable, processInstance = _r.processInstance, activations = _r.activations, groupedCases = _r.groupedCases, modalURL = _r.modalURL, hostCaseId = _r.hostCaseId, onChargeSessionAction = _r.onChargeSessionAction, activity = _r.activity, prompt = _r.prompt, confirm = _r.confirm, showSubmittedFeedback = _r.showSubmittedFeedback, showLoadingSubmission = _r.showLoadingSubmission, showLoadingCancelation = _r.showLoadingCancelation, showSizeExpWarning = _r.showSizeExpWarning, showCanceledFeedback = _r.showCanceledFeedback, submittedFeedbackTimer = _r.submittedFeedbackTimer, showvitalwareIssuesModal = _r.showvitalwareIssuesModal, toggleHoldCaseModal = _r.toggleHoldCaseModal, toggleExclusionCaseModal = _r.toggleExclusionCaseModal, toggleSplitCaseModal = _r.toggleSplitCaseModal, vitalwareIssues = _r.vitalwareIssues, mergeSplitHistoryIssues = _r.mergeSplitHistoryIssues, documentImprovementIssues = _r.documentImprovementIssues, holdIssues = _r.holdIssues, hidevitalwareIssuesModal = _r.hidevitalwareIssuesModal, displayAddCharge = _r.displayAddCharge, showAddChargeError = _r.showAddChargeError, showAddChargeLoading = _r.showAddChargeLoading, loadState = _r.loadState, codableInvoices = _r.codableInvoices, feedback = _r.feedback, showFeedBack = _r.showFeedBack, UIMode = _r.UIMode, epicToken = _r.epicToken, codeEdits = _r.codeEdits, invoiceOptions = _r.invoiceOptions, caseEdits = _r.caseEdits, showHoldCaseModal = _r.showHoldCaseModal, hideHoldCaseModal = _r.hideHoldCaseModal, showExclusionCaseModal = _r.showExclusionCaseModal, hideExclusionCaseModal = _r.hideExclusionCaseModal, toggleChargeableCase = _r.toggleChargeableCase, holdCase = _r.holdCase, improvements = _r.improvements, capabilities = _r.capabilities, updateValue = _r.updateValue, updateCase = _r.updateCase, relatedCases = _r.relatedCases, relatedCasesPageable = _r.relatedCasesPageable, flagList = _r.flagList, htmlNotes = _r.htmlNotes, customClaimsRelatedCases = _r.customClaimsRelatedCases, customClaimsRelatedCasesLoadState = _r.customClaimsRelatedCasesLoadState, organization = _r.organization, benchMode = _r.benchMode, caseVersions = _r.caseVersions, gradeableInvoices = _r.gradeableInvoices, fieldDefinitions = _r.fieldDefinitions, riskCategories = _r.riskCategories, cqaCodeAssessmentRiskDictionaries = _r.cqaCodeAssessmentRiskDictionaries, onGradeUpdate = _r.onGradeUpdate, onGradeRemove = _r.onGradeRemove, onCodeEvent = _r.onCodeEvent, onCreateCQATransaction = _r.onCreateCQATransaction, onDeleteCQATransaction = _r.onDeleteCQATransaction, workItem = _r.workItem, suggestedCodes = _r.suggestedCodes, associatedWorkitems = _r.associatedWorkitems, loadAssociatedWorkItem = _r.loadAssociatedWorkItem, caseDetailProps = __rest(_r, ["nonCodeBench", "chargeSessions", "counts", "searchResults", "codeSearchResultsV2", "benchEditable", "processInstance", "activations", "groupedCases", "modalURL", "hostCaseId", "onChargeSessionAction", "activity", "prompt", "confirm", "showSubmittedFeedback", "showLoadingSubmission", "showLoadingCancelation", "showSizeExpWarning", "showCanceledFeedback", "submittedFeedbackTimer", "showvitalwareIssuesModal", "toggleHoldCaseModal", "toggleExclusionCaseModal", "toggleSplitCaseModal", "vitalwareIssues", "mergeSplitHistoryIssues", "documentImprovementIssues", "holdIssues", "hidevitalwareIssuesModal", "displayAddCharge", "showAddChargeError", "showAddChargeLoading", "loadState", "codableInvoices", "feedback", "showFeedBack", "UIMode", "epicToken", "codeEdits", "invoiceOptions", "caseEdits", "showHoldCaseModal", "hideHoldCaseModal", "showExclusionCaseModal", "hideExclusionCaseModal", "toggleChargeableCase", "holdCase", "improvements", "capabilities", "updateValue", "updateCase", "relatedCases", "relatedCasesPageable", "flagList", "htmlNotes", "customClaimsRelatedCases", "customClaimsRelatedCasesLoadState", "organization", "benchMode", "caseVersions", "gradeableInvoices", "fieldDefinitions", "riskCategories", "cqaCodeAssessmentRiskDictionaries", "onGradeUpdate", "onGradeRemove", "onCodeEvent", "onCreateCQATransaction", "onDeleteCQATransaction", "workItem", "suggestedCodes", "associatedWorkitems", "loadAssociatedWorkItem"]);
        function handleOpenCase(processInstanceGuid, caseUid) {
            var _a, _b;
            if (processInstanceGuid) {
                var childWindowParams = getChildWindowParams(caseUid !== null && caseUid !== void 0 ? caseUid : (_a = caseDetailProps.activeItem) === null || _a === void 0 ? void 0 : _a.case_uid, processInstanceGuid, (_b = caseDetailProps.activeItem) === null || _b === void 0 ? void 0 : _b.service_line, window_open_args_1.launchAmplifyCase);
                caseDetailProps.openChildWindow(childWindowParams);
            }
        }
        var currentVersionPosition = (_a = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.findIndex(function (caseVersion) { var _a; return caseVersion.processInstanceGuid === ((_a = processInstance === null || processInstance === void 0 ? void 0 : processInstance.guid) === null || _a === void 0 ? void 0 : _a.uuid); })) !== null && _a !== void 0 ? _a : -1;
        var previousVersions = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.filter(function (_, index) { return index < currentVersionPosition; });
        var previousSentCase = previousVersions === null || previousVersions === void 0 ? void 0 : previousVersions.find(function (previousVersion) {
            return previousVersion.processInstanceStatus ===
                AccelerateProcessStatus.SUBMITTED ||
                previousVersion.processInstanceStatus ===
                    AccelerateProcessStatus.CANCELLED ||
                previousVersion.processInstanceStatus === AccelerateProcessStatus.SENT;
        });
        var newestVersionObject = (caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.length) > 0 ? caseVersions[caseVersions.length - 1] : null;
        var flagListSet = Array.from(new Set(flagList === null || flagList === void 0 ? void 0 : flagList.map(function (flag) { return flag === null || flag === void 0 ? void 0 : flag.flag; })));
        var submitHandler = null;
        if (benchMode == ui_common_1.commonEnums.BenchMode.GRADE) {
            var updatedStatus = 'CQA_COMPLETE';
            if (gradeableInvoices.length > 0 &&
                gradeableInvoices[0].status == 'CQA_COMPLETE') {
                updatedStatus = 'CQA_APPROVED';
            }
            submitHandler = (0, code_bench_action_bar_component_utilities_1.createSubmitCQAWorkItemHandler)(this.props.cursorAPIContext, this.props.submitCQAWorkitem, updatedStatus);
        }
        else {
            submitHandler = (0, code_bench_action_bar_component_utilities_1.createSubmitCaseHandler)(UIMode, this.props.onInvoicesSubmisson, this.props.processInstance, this.props.cursorAPIContext, this.props.caseAccessTime, this.props.activeItem, this.props.getCaseVersions, this.props.toggleSubmitOldCaseModal, conditionalUtils.capabilityValue((_c = (_b = capabilities.capabilities.amplifyCaseRunV2) === null || _b === void 0 ? void 0 : _b.on) !== null && _c !== void 0 ? _c : false));
        }
        var actionBarSelectMultipleWorkitems = conditionalUtils.capabilityValue((_f = (_e = (_d = this.props.capabilities) === null || _d === void 0 ? void 0 : _d.capabilities) === null || _e === void 0 ? void 0 : _e.actionBarSelectMultipleWorkitems) === null || _f === void 0 ? void 0 : _f.on);
        var onCursorActionHandler = this.props.onCursorAction;
        if (benchMode == ui_common_1.commonEnums.BenchMode.GRADE &&
            actionBarSelectMultipleWorkitems) {
            onCursorActionHandler = function (cursorAPIPayload) {
                if (associatedWorkitems && associatedWorkitems.length > 0) {
                    var workitemId = associatedWorkitems[associatedWorkitems.length - 1].data.case_id;
                    cursorAPIPayload.cursorAPIContext.workitemId = workitemId;
                    _this.props.onCursorAction(cursorAPIPayload);
                }
            };
        }
        var _s = __read((0, workitem_selector_1.getSelectedWorkitemFromInvoice)(this.props.cursorAPIContext, associatedWorkitems), 2), selectedWorkitem = _s[0], selectedWorkitemIndex = _s[1];
        var groupedWorkitems = (0, workitem_selector_1.GroupWorkitemsByStatus)(associatedWorkitems);
        var workitemSelectorProps = {
            items: groupedWorkitems,
            selectedItem: selectedWorkitem,
            getItemLabel: function (item) { return (0, workitem_selector_1.renderWorkItemLabel)(item); },
            onItemSelect: function (item) {
                return loadAssociatedWorkItem(_this.props.cursorAPIContext, item);
            },
            renderItem: function (item) { return (0, workitem_selector_1.renderWorkitemInItemSelector)(item); },
            buttonLabel: ((_g = selectedWorkitem === null || selectedWorkitem === void 0 ? void 0 : selectedWorkitem.data) === null || _g === void 0 ? void 0 : _g.assignee)
                ? "".concat((_h = selectedWorkitem === null || selectedWorkitem === void 0 ? void 0 : selectedWorkitem.data) === null || _h === void 0 ? void 0 : _h.assignee)
                : 'Select Workitem',
            prefixTitle: '',
            className: 'action-bar-item-selector',
            disabled: false,
            disableWhenSingle: false,
            isSelected: workitem_selector_1.isWorkitemSelected,
            secondaryLabel: "".concat(selectedWorkitemIndex + 1, " of ").concat(associatedWorkitems.length),
            isGrouped: true
        };
        var actionBar = (
        //@ts-ignore
        (0, jsx_runtime_1.jsx)(code_bench_action_barv2_1.CodeBenchActionBarv2, __assign({}, this.props, { handleSubmitCase: submitHandler, itemSelectorProps: actionBarSelectMultipleWorkitems && associatedWorkitems.length > 0
                ? workitemSelectorProps
                : undefined, onCursorAction: onCursorActionHandler, onNextVersion: this.props.onCursorAction })));
        var codeEditingPanel;
        var button, relatedCasesView;
        var isActive = !ui_common_1.caseUtils.isFinishedCase(caseDetailProps.activeItem);
        if (showSubmittedFeedback || showCanceledFeedback) {
            if (submittedFeedbackTimer) {
                window.parent.postMessage({
                    action: 'Epic.Clinical.Informatics.Web.CloseActivity',
                    token: epicToken
                }, '*');
            }
            else {
                this.handleTimer();
            }
        }
        var showProcessStatus = !benchEditable.editable;
        var showModal = modalURL !== null && modalURL.path;
        var modalURI = showModal ? modalURL.path + modalURL.queryString : '';
        var benchLoading = loadState.loading;
        var invoices = (_j = invoiceOptions === null || invoiceOptions === void 0 ? void 0 : invoiceOptions.invoices) !== null && _j !== void 0 ? _j : [];
        var hasStatusReason = ui_common_1.caseUtils.getStatusReason(caseDetailProps.activeItem);
        var styles = (0, classnames_1["default"])([
            'code-benchv2',
            {
                'bench-pre-editable': benchEditable.waiting,
                'bench-cancelled': benchEditable.cancelled,
                'bench-loading': benchLoading
            }
        ]);
        if (benchEditable.waiting) {
            codeEditingPanel = (0, jsx_runtime_1.jsx)(process_status_1.ProcessStatus, { benchEditable: benchEditable });
        }
        else {
            var noCodableInvoices = codableInvoices === null || codableInvoices.length === 0;
            var noGradeableInvoice = gradeableInvoices == null || gradeableInvoices.length === 0;
            var noCharges = noCodableInvoices && noGradeableInvoice;
            var summarySection = ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "summary-section" }, { children: [(0, jsx_runtime_1.jsx)("h5", { children: "Summary" }), (0, jsx_runtime_1.jsx)(charge_counts_1.ChargeCounts, { counts: counts })] }), "charge-totals") }));
            var panel = benchMode == ui_common_1.commonEnums.BenchMode.CODE ? ((0, jsx_runtime_1.jsx)(code_bench_panelv2_1.CodeBenchPanelv2, { panelActivations: activations.panel, onChargeSessionAction: this.handleMetaAction, onFeatureSelection: this.onFeatureSelection, editable: benchEditable.editable, benchEditable: benchEditable, caseDetailProps: caseDetailProps, searchResults: searchResults, codeSearchResultsV2: codeSearchResultsV2, benchLoading: benchLoading, codeEdits: codeEdits, onInvoiceMetaEdit: this.handleInvoiceEdit, onCodeSearchSelection: this.onCodeSearchSelection, handleAddAllCodes: this.onAddAllCodes, handleRemoveAllCodes: this.onRemoveAllCodes, createTransactionAndAddCode: this.createTransactionAndAddCode, onCodeSearch: this.onCodeSearch, onCodeUpdate: this.onCodeUpdate, onCodeRemove: this.onCodeRemove, onTimeBasedCodeAdd: this.onTimeBasedCodeAdd, onTimeBasedCodeUpdate: this.onTimeBasedCodeUpdate, onCodeSearchDrop: this.onCodeSearchDrop, onTransactionSharedDiagnosisChange: this.handleTransactionSharedDiagnosisChange, counts: counts, processInstance: processInstance, codableInvoices: codableInvoices, showProcessStatus: showProcessStatus, handleEnableTechPro: this.handleEnableTechPro, handleDisableTechPro: this.handleDisableTechPro, customClaimsRelatedCases: this.props.customClaimsRelatedCases, customClaimsRelatedCasesLoadState: this.props.customClaimsRelatedCasesLoadState, openChildWindow: this.props.openChildWindow, handleInvoiceAddition: function () {
                    return _this.handleInvoiceAddition(invoices);
                }, onInvoiceRemove: this.props.onInvoiceRemove, summarySection: summarySection, transactionV2: conditionalUtils.capabilityValue((_k = capabilities.capabilities.transactionV2) === null || _k === void 0 ? void 0 : _k.on), suggestedCodes: suggestedCodes }, "code-bench-panel")) : ((0, jsx_runtime_1.jsx)(grade_bench_panel_generalized_1["default"], { invoiceMetadataFields: invoice_metadata_form_fixtures_1.InvoiceMetadataFormFieldsCQA, cptFields: fieldDefinitions.cptFields, icdFields: fieldDefinitions.icdFields, modifierFields: fieldDefinitions.modifierFields, gradeableInvoices: gradeableInvoices, onCodeUpdate: onGradeUpdate, onCodeRemove: onGradeRemove, onCodeEvent: onCodeEvent, codeSearch: {
                    onCodeSearch: this.onCodeSearch,
                    //Code search selection and drop are disabled for now, until gradebench gets its own codeUpdate actions
                    onCodeSearchSelection: this.onCodeSearchSelection,
                    onCodeSearchDrop: function () { },
                    searchResults: searchResults
                }, onCreateCQATransaction: onCreateCQATransaction, onDeleteCQATransaction: onDeleteCQATransaction, projectConfiguration: this.props.qaRuleCollection.project_configuration, riskCategories: riskCategories, cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries, gradingErrors: this.props.gradingErrors }, "grade-bench-panel"));
            var innerBench = (noCodableInvoices && codableInvoices === null) || loadState.loading ? ((0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 3 }, "loading-slugs")) : ([
                noCharges ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "no-charges empty-message" }, { children: "No charges found." }))) : (panel)
            ]);
            if (ui_common_1.AmplifyCore.isIPCServiceline(this.props.activeItem.service_line)) {
                relatedCasesView = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(standalone_pageable_list_1.StandalonePageableList, __assign({ list: this.handleHARCaseList, sortablePageable: relatedCasesPageable, theme: 'cmx-theme' }, { children: (0, jsx_runtime_1.jsx)(related_cases_1.RelatedCases, { relatedCases: relatedCases, showLoading: benchLoading || caseDetailProps.relatedCasesLoadState.loading, activeItem: this.props.activeItem, onOpenRelatedCase: this.props.openChildWindow, showProviderInfo: this.props.showProviderInfo }) })) }));
            }
            else {
                relatedCasesView = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: benchLoading || caseDetailProps.billingGroupLoadState.loading ? ((0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 1 }, "loading-slugs")) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "status-section", onClick: this.handleGroupedCaseClick }, { children: (0, jsx_runtime_1.jsx)(billing_group_1.BillingGroup, { suppressedLinks: [hostCaseId], showProcessStatus: true, isActive: isActive, cancelled: benchEditable.cancelled, groupedCases: groupedCases, showLoading: caseDetailProps.billingGroupLoadState.loading, viewOnly: !benchEditable.editable }) }))) }));
            }
            codeEditingPanel = [
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [benchMode == ui_common_1.commonEnums.BenchMode.GRADE ? ((0, jsx_runtime_1.jsx)(purpose_guideline_1.PurposeAndGuideline, { purpose: this.props.qaRuleCollection.sampleReason, guideline: this.props.qaRuleCollection.guideline })) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "status-area conditional-view ".concat(!hasStatusReason ? 'default-display-none-on-false' : '') }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "status-section case-status-section" }, { children: benchLoading ? ((0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 1 }, "loading-slugs")) : ((0, jsx_runtime_1.jsx)(case_status_1.StatusDescription, { secondaryPrefix: "Review Required", includeBox: true, caseRun: caseDetailProps.activeItem })) })) }))), benchLoading ? ((0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 2 }, "loading-slugs")) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({}, capabilities.capabilities.previousSentCaseAlert, { children: (0, jsx_runtime_1.jsxs)(case_alert_1.CaseAlert, __assign({ alertType: CaseAlertType.ERROR }, { children: ["This is an update to a", ' ', (0, jsx_runtime_1.jsx)("a", __assign({ className: "anchor-chakra-link", onClick: function () {
                                                    return handleOpenCase(previousSentCase === null || previousSentCase === void 0 ? void 0 : previousSentCase.processInstanceGuid);
                                                } }, { children: "previously submitted case" })), "."] })) })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({}, capabilities.capabilities.oldCaseLoadedAlert, { children: (0, jsx_runtime_1.jsxs)(case_alert_1.CaseAlert, __assign({ alertType: CaseAlertType.WARNING }, { children: ["You are viewing an older version of this case. View the", ' ', (0, jsx_runtime_1.jsx)("a", __assign({ className: "anchor-chakra-link", onClick: function () {
                                                    return handleOpenCase(newestVersionObject === null || newestVersionObject === void 0 ? void 0 : newestVersionObject.processInstanceGuid);
                                                } }, { children: "current version" }))] })) })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ some: [!!((_l = this.props.activeItem) === null || _l === void 0 ? void 0 : _l.parent_process_instance_uid)] }, { children: (0, jsx_runtime_1.jsx)(case_alert_1.CaseAlert, __assign({ alertType: CaseAlertType.INFO, alertSize: "sm" }, { children: (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [
                                                (_o = !!((_m = this.props.activeItem) === null || _m === void 0 ? void 0 : _m.parent_process_instance_uid)) !== null && _o !== void 0 ? _o : false
                                            ] }, { children: (0, jsx_runtime_1.jsxs)("span", { children: ["This case is no longer active. It has been merged into: case", (0, jsx_runtime_1.jsxs)("a", __assign({ className: "anchor-chakra-link", onClick: function () {
                                                            var _a, _b;
                                                            return handleOpenCase((_a = _this.props.activeItem) === null || _a === void 0 ? void 0 : _a.parent_caserun_uid, (_b = _this.props.activeItem) === null || _b === void 0 ? void 0 : _b.parent_case_uid);
                                                        } }, { children: [' ', "#", (_p = this.props.activeItem) === null || _p === void 0 ? void 0 : _p.parent_case_id] }))] }) })) })) }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "charge-sessions" }, { children: innerBench })), UIMode === ui_common_1.commonEnums.UIModesEnum.EPIC_EMBEDDED ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "debug-box" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ className: "debug-link", href: "/debug" }, { children: "Debug" })) }))) : ('')] })
            ];
        }
        var _updatedPropertyConfig = updatePropertyConfig({
            benchMode: benchMode,
            serviceLine: this.props.activeItem.service_line,
            propertyConfig: this.props.propertyConfig
        });
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles }, { children: [prompt && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "top-level-modal" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ title: prompt.text, closable: false, onSubmit: this.handlePromptDismiss, buttonText: "Yes", maximize: false }, { children: (0, jsx_runtime_1.jsxs)("p", { children: ["Click ", (0, jsx_runtime_1.jsx)("b", { children: "Yes" }), " below to stay logged in."] }) })) }))), (0, jsx_runtime_1.jsx)(confirm_1.Confirm, __assign({ onConfirm: this.props.handleConfirm, onDismiss: this.props.handleConfirmDismiss }, confirm)), showModal && ((0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ onClose: this.handleModalClose, maximize: true }, { children: (0, jsx_runtime_1.jsx)("iframe", { ref: this.iframeRef, src: modalURI, className: "popup-frame" }) }))), (showSubmittedFeedback || showCanceledFeedback) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "qa-submitted-modal" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.UniversalFeedback, { feedback: {
                            message: "Successfully ".concat(showSubmittedFeedback ? 'submitted' : 'canceled'),
                            id: new Date().getTime(),
                            dismissable: true
                        }, showingTime: 3000, dismissFeedback: this.props.hideSubmittedFeedback, showFeedback: showSubmittedFeedback || showCanceledFeedback }) }))), (showLoadingSubmission || showLoadingCancelation) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "qa-submitted-modal" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.UniversalFeedback, { feedback: {
                            message: "".concat(showLoadingSubmission ? 'Submitting...' : 'Canceling...'),
                            id: new Date().getTime(),
                            dismissable: false,
                            meta: { level: ui_common_1.commonEnums.FeedbackMeta.WARNING }
                        }, showFeedback: showLoadingSubmission || showLoadingCancelation }) }))), displayAddCharge && ((0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ onClose: this.onModalAddChargeClose, title: showAddChargeLoading ? 'Adding charge' : 'Add a charge for:' }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "qa-add-charge-modal" }, { children: [!showAddChargeLoading ? ((0, jsx_runtime_1.jsx)(charge_selector_1.ChargeSelector, { handleAddCharge: this.handleAddCharge, handleInvoiceAddition: this.handleInvoiceAddition, invoiceOptions: invoiceOptions })) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "spinner-box" }, { children: (0, jsx_runtime_1.jsx)("img", { src: spinner_svg_1["default"], alt: "in progress", className: "spinner" }) }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: "charge-error-box" }, { children: showAddChargeError ? ((0, jsx_runtime_1.jsx)("small", __assign({ className: "charge-error-text" }, { children: "Error adding a new charge" }))) : ('') }))] })) }))), (0, jsx_runtime_1.jsx)(case_detailv2_1.CaseDetailv2, __assign({ ref: this.caseDetailRef, mode: "code-edit", codeEdits: codeEdits, codeEditingPanel: codeEditingPanel, groupedCases: groupedCases }, __assign(__assign({}, caseDetailProps), { propertyConfig: benchMode === ui_common_1.commonEnums.BenchMode.GRADE
                        ? _updatedPropertyConfig
                        : caseDetailProps.propertyConfig }), { loadState: loadState, activations: activations, actionBar: actionBar, updateValue: updateValue, updateCase: updateCase, showAttachDocsModal: this.props.showAttachDocsModal, capability: capabilities.capabilities.caseEdit, coderNotesCapability: capabilities.capabilities.coderNotes, capabilities: capabilities, processInstance: this.props.processInstance, caseEdits: caseEdits, noteUnavailableReason: capabilities.capabilities.noteUnavailableReason, UIMode: this.props.UIMode, flagList: flagList, relatedCasesView: relatedCasesView, activity: activity, documentImprovementsPanel: (0, jsx_runtime_1.jsx)(improvements_1.Improvements, __assign({}, this.props, { improvementsAction: capabilities.capabilities.improvementsAction, showUnresolved: this.props.showUnresolvedDocuments })), showCoderNotesInfo: this.props.showCoderNotesInfo, workItem: workItem, displayTopLeftPatientInfo: !(this.props.benchMode == ui_common_1.commonEnums.BenchMode.GRADE), editable: benchEditable.editable })), (0, jsx_runtime_1.jsx)(ui_components_1.UniversalFeedback, { feedback: feedback, dismissFeedback: this.props.hideFeedback, showFeedback: showFeedBack, showingTime: 5000 }), showSizeExpWarning && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "top-level-modal" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ title: 'Help us improve your experience', closable: true, onClose: this.handleDeleteSizeExpWarning, onSubmit: this.handleDeleteSizeExpWarning, buttonText: "Dismiss", maximize: false }, { children: (0, jsx_runtime_1.jsx)("p", { children: "Consider adjusting the width of your browser to a wider setting for a better view of CMX Amplify." }) })) }))), showvitalwareIssuesModal && ((0, jsx_runtime_1.jsx)(code_bench_vw_modal_1["default"], { onClose: this.props.hidevitalwareIssuesModal, onSubmit: function (event, comment, remove_hold) {
                        return _this.handleSubmit(event, comment, true, remove_hold);
                    }, vitalwareIssues: vitalwareIssues, mergeSplitHistoryIssues: mergeSplitHistoryIssues, documentImprovementIssues: documentImprovementIssues, holdIssues: holdIssues, holdCaseStatus: capabilities.holdCaseStatus, improvements: (_q = this.props.improvements) === null || _q === void 0 ? void 0 : _q.improvements, setActiveMiniTab: this.props.setActiveVerticalMiniTab, setUnresolvedDocuments: this.props.setUnresolvedDocuments }))] })));
    };
    CodeBenchv2.defaultProps = {
        suggestedCodes: {
            cpt: [],
            modifier: [],
            diagnosis: []
        },
        benchEditable: __assign({}, ui_common_1.AmplifyCore.state.DEFAULT_BENCH_EDITABLE),
        improvements: __assign({}, ui_common_1.AmplifyCore.state.improvements),
        capabilities: __assign({}, ui_common_1.AmplifyCore.state.capabilities),
        relatedCasesLoadState: __assign({}, ui_common_1.loadStates.LOAD_STATES.done),
        relatedCasesPageable: __assign({}, ui_common_1.AmplifyCore.paginationUtils.relatedCasesSortablePageable),
        processInstanceGuids: [],
        hostCaseId: null,
        loadAlwaysFromURL: false,
        propertyConfig: {
            patient: [],
            summary: [],
            expanded: []
        },
        confirm: {
            display: false,
            title: ''
        },
        activity: [],
        noteTypes: [],
        workItem: {
            assignee: '',
            owner: '',
            aging_days: '',
            codable_days: ''
        },
        onLoad: function (caseRun) { },
        onChargeSessionAction: function (transactionAction) { },
        onReload: function (params) { },
        onSearchClear: function (codeQuery) { },
        onCodeSearch: function (codeQuery) { },
        onCodeSearchSelection: function (searchSelection) { },
        handleAddAllCodes: function (searchSelection) { },
        handleRemoveAllCodes: function (codeChange) { },
        createTransactionAndAddCode: function (searchSelection) { },
        onChargeSessionMetaEdit: function (chargeSession) { },
        onCodeUpdate: function (changeDetail) { },
        onCodeRemove: function (changeDetail) { },
        onTimeBasedCodeAdd: function (time, age) { },
        onTimeBasedCodeUpdate: function (time, age) { },
        onCodeSearchDrop: function (changeDetail) { },
        onTransactionSharedDiagnosisChange: function (changeDetail) { },
        onPrompt: function (action) { },
        onPopUpClose: function () { },
        onFeatureActivation: function (selection) { },
        onNavigate: function (caseId, replace, serviceLine) { },
        hidevitalwareIssuesModal: function () { },
        onImprovementAdd: function (documentImprovement) { },
        onImprovementUpdate: function (documentImprovement) { },
        onImprovementRemove: function (documentImprovement) { },
        onProviderAdd: function (documentImprovement) { },
        onProviderRemove: function (documentImprovement) { },
        onProviderUpdate: function (documentImprovement) { },
        onDocumentImprovementSearch: function (codeQuery) { },
        showAmplifyFeedback: function (feedback) { },
        onProviderSearch: function (query) { },
        updateValue: function (val) { },
        updateCase: function (idAndUpdates) { },
        loadRoles: function (roles) { },
        getFlagItems: function (activeItem) { },
        setActiveMiniTab: function (activeTabName) { },
        setActiveVerticalMiniTab: function (activeTabName) { },
        setUnresolvedDocuments: function (value) { },
        showCoderNotesInfo: function (coderNotesParams) { },
        onInvoiceRemove: function (invoiceDeleteParams) { },
        searchResults: {},
        codeSearchResultsV2: {},
        displayAddCharge: false,
        showAddChargeError: false,
        showLoadingSubmission: false,
        showLoadingCancelation: false,
        showSizeExpWarning: false,
        showFeedBack: false,
        showSubmittedFeedback: false,
        showCanceledFeedback: false,
        submittedFeedbackTimer: false,
        showvitalwareIssuesModal: false,
        toggleHoldCaseModal: false,
        toggleExclusionCaseModal: false,
        toggleSplitCaseModal: false,
        submitOldCaseModal: false,
        vitalwareIssues: [],
        mergeSplitHistoryIssues: [],
        caseAccessTime: '',
        activeMiniTab: ui_common_1.commonEnums.MiniTabLabels.CHARGES_LABEL,
        activeVerticalMiniTab: ui_common_1.commonEnums.MiniTabLabels.NOTES_LABEL,
        showUnresolvedDocuments: false,
        gradeableInvoices: [],
        qaRuleCollection: {
            sampleReason: '',
            guideline: ''
        },
        associatedWorkitems: []
    };
    return CodeBenchv2;
}(react_1["default"].Component));
exports.CodeBenchv2 = CodeBenchv2;
//# sourceMappingURL=code-benchv2.js.map